export default __webpack_public_path__ + "static/media/Lora-Bold.9d66e80d.ttf";